import LazyLoad from "vanilla-lazyload";

const createLazyLoadInstance = new LazyLoad({
    elements_selector: ".lazy",
    to_webp: true,
});

$(document).ready(function () {
    const isiOS = (navigator.userAgent.match(/(iPad|iPhone|iPod)/g) ? true : false);
    if (isiOS) {
        $('body').css('cursor', 'pointer');
    }
    document.addEventListener('scroll', () => {
        createLazyLoadInstance.update();
    });
    $("[data-toggle=popover]").popover({
        html: true,
        trigger: 'click',
        placement: 'bottom',
        content: function () {
            const content = $(this).attr("data-popover-content");
            return $(content).html();
        },
    }).on("show.bs.popover", function (e) {
        $("[data-toggle=popover]").not(e.target).popover("hide");
        $(".popover").remove();
    });

    $('#nav-icon').click(function () {
        $('.mobile-menu').toggleClass('active');
        $('.nav-icon span').attr('style', 'background: transparent');
    });

    $('#close-btn').click(function () {
        $('.mobile-menu').removeClass('active');
        $('.nav-icon span').attr('style', 'background: #d89d11');
    });

    $('#close-btn_').click(function () {
        $('.mobile-menu').removeClass('active');
        $('.nav-icon span').attr('style', 'background: #d89d11');
    });

    document.addEventListener('scroll', function () {
        $("[data-toggle=popover]").popover('hide')
    }, true);

    $(document).mouseup(function (e) {
        const div = $('.popover');
        if (!div.is(e.target)
            && div.has(e.target).length === 0) {
            $("[data-toggle=popover]").popover('hide')
        }
    });
    $(document).on('click', '.dropdown-menu label', function (e) {
        e.stopPropagation();
    });
    $(window).on('scroll', function () {
        $("[data-toggle=popover]").popover('hide')

        if ($(window).scrollTop() > 50) {
            $('.main-top').addClass('fixed-topbar');
        } else {
            $('.main-top').removeClass('fixed-topbar');
        }
    })
    $(document).on('focus', 'input[type=number]', function (e) {
        $(this).on('wheel.disableScroll', function (e) {
            e.preventDefault()
        })
    })
    $(document).on('blur', 'input[type=number]', function (e) {
        $(this).off('wheel.disableScroll')
    })
    $('.alfa-payment__button').on('click', function (e){
        let $body = $("body");
        $body.addClass('modal-open');
    })
    $(document).on('click', '.alfa-payment__payment-close-button',function (e){
        let $body = $("body");
        $body.removeClass('modal-open');
    })
    $(document).on('click', '.scrolled',function (e){
        const el = document.getElementsByClassName(e.target.dataset.scrollTo)[0];
        $([document.documentElement, document.body]).animate({
            scrollTop: $(el).offset().top
        }, 1500);
    })

})
